var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        numberFilterTree: 2,
    }
};
// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="1 Grid__Cell 1/'+ bcSfFilterConfig.custom.mobile_row + '--phone 1/' + bcSfFilterConfig.custom.tablet_row + '--tablet-and-up 1/' + bcSfFilterConfig.custom.desktop_row + '--' + buildClass() +'">'+
                              '<div class="ProductItem '+ buildClassHiz() +' ">'+
                                '<div class="ProductItem__Wrapper">'+
                                  '{{itemWishlist}}' +
                                  '{{itemImages}}' +
                                  '{{itemReviews}}'+
                                  '{{itemLabels}}'+
                                  '{{itemInfo}}'+
                                  '{{itemAction}}'+
                                '</div>'+
                                buildButtonSecond() +
                              '</div>'+
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="prev" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></a>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<a class="Pagination__NavItem Link Link--primary" rel="next" href="{{itemUrl}}"><svg class="{{ icon_class }}" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg></a>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<a class="Pagination__NavItem Link Link--primary" href="{{itemUrl}}">{{itemTitle}}</a>',
    'pageItemSelectedHtml': '<span class="Pagination__NavItem buildPagination">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="Pagination__NavItem">{{itemTitle}}</span>',
    'paginateHtml': ' <div class="Pagination Text--subdued"><div class="Pagination__Nav">{{previous}}{{pageItems}}{{next}}</div></div>',
    // Sorting Template
    'sortingHtml': '{{sortingItems}}',

};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImage(data, images));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));
  itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data, index));
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data, index));
  itemHtml = itemHtml.replace(/{{itemAction}}/g, buildAction(data, index));
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
};

BCSfFilter.prototype.buildProductItemUrl = function(data) {
  return '/products/' + data.handle;
}

/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildClass() {
  return bcSfFilterConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
}

function buildClassHiz() {
  return bcSfFilterConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
}

function buildButtonSecond() {
  return bcSfFilterConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + bcSfFilterConfig.label.view_product + '</a>' : '';
}

function buildImage(data, images) {
  var htmlImg = '';
  if (images.length > 0) {
    htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
    var use_natural_size = false;
    var has_alternate_image = false;
    if (bcSfFilterConfig.custom.product_image_size == 'natural' || bcSfFilterConfig.custom.use_horizontal)
      use_natural_size = true;
    if (bcSfFilterConfig.custom.product_show_secondary_image && images.length > 1 && !bcSfFilterConfig.custom.use_horizontal)
      has_alternate_image = true;
    if (has_alternate_image)
      htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
    htmlImg += '">';
    var max_width = images[0].width;
    if (bcSfFilterConfig.custom.use_horizontal)
      max_width = 125;
    var withCall = use_natural_size ? 'withFallback' : bcSfFilterConfig.custom.product_image_size;
    htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
    var aspect_ratio = images[0].width / images[0].height;
    if (use_natural_size) {
      htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
    }
    htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';
    if (has_alternate_image && images.length > 1) {
      var sizes = '200,300,400,600,800,900,1000,1200';
      var support_size = imageSize(sizes, images[1]);
      var thumbUrl = bcsffilter.optimizeImage(images[1]['src'], '{width}x');
      htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '&1" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }

    var sizes_main = '200,400,600,700,800,900,1000,1200';
    var support_size = imageSize(sizes_main, images[0]);
    var thumbUrl_main = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src'], '{width}x') : bcSfFilterConfig.general.no_image_url;
    htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn " data-src="' + thumbUrl_main + '&1" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
    htmlImg += '<span class="Image__Loader"></span>';
    htmlImg += '<noscript>';
    htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + bcsffilter.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '<img class="ProductItem__Image" src="' + bcsffilter.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
    htmlImg += '</noscript>';
    htmlImg += '</div>';
    htmlImg += '</a>';
  }
  else {
    htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper"><div class="AspectRatio AspectRatio--withFallback" style="max-width: 2250px;padding-bottom: 100%; --aspect-ratio: 1"></div></a>';
  }
  return htmlImg;
}

function imageSize(sizes, image) {
  if (image) {
    var desired_sizes = sizes.split(',');
    var supported_sizes = '';
    for (var k = 0; k < desired_sizes.length; k++) {
      var size = desired_sizes[k];
      var size_as_int = size * 1;
      if (image.width < size_as_int) { break; }
      supported_sizes = supported_sizes + size + ',';
    }
    
    if (supported_sizes == '')
      supported_sizes = image.width;

    if(!jQ.isNumeric(supported_sizes)) {
      supported_sizes = supported_sizes.split(',').join(',');
      supported_sizes = supported_sizes.substring(0,supported_sizes.lastIndexOf(','));
    }
    return supported_sizes;
    
  } else {
    return '';
  }
}

function buildPrice(data) {
  var html = '';
  var show_price_on_hover = bcSfFilterConfig.custom.product_show_price_on_hover;
  var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
  html += '<div class="ProductItem__PriceList ' + classPriceHover + ' Heading">';
  
  if(data.product_type == 'Membership' || data.product_type == 'membership'){
    let discountedPriceMoney = 0;
    let discountDecimal = window.shop.membershipProduct.discount_in_decimal;
    var direct_link = localStorage.getItem('party_information');
    
    if (direct_link){
      discountedPriceMoney = data.price_min * discountDecimal;
    }

    html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(discountedPriceMoney) + '</span> ';
    html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(data.price_min) + '</span>';
  }
  else {
    if (onSale) {
      var price_main = data.price_min / 100.00
      var price_com = data.compare_at_price_min / 100.00
     var discount_custom = Math.round(((price_com - price_main) * 100.00) / price_com);
      html += '<span class="ProductItem__Price Price Price--highlight without_customer_disc Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(data.price_min) + '</span> ';
      html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</span>';
      html += '<span class="Product_discount Price--highlight discount_price_end_user" >' + discount_custom + '% Off'+ '</span>';
    } else {
      if (priceVaries) {
        html += '<span class="ProductItem__Price Price Text--subdued">' + bcSfFilterConfig.label.from.replace(/{{min_price}}/g, bcsffilter.formatMoney(data.price_min)) + '</span>';
      } else {
        var special_discount = $('.CollectionInner__Products').attr('discount_const');
        special_discount = parseInt(special_discount);
        var mrp = (data.price_min / 100).toFixed(2);
        var regular_customer_price = mrp - (((data.price_min * special_discount)/10000).toFixed(2));
        if(document.body.classList.contains('regular_customer')){
          // html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>'+ bcsffilter.formatMoney(data.price_min) + '</span>';
        html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</span>';
        }
        else if(!document.body.classList.contains('regular_customer') && !document.body.classList.contains('special_customer')){
          // console.log((data.price_min < data.compare_at_price_min),data ,'-----',bcSfFilterConfig.label.from.replace(/{{min_price}}/g, bcsffilter.formatMoney(data.price_min)));
          html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(data.price_min) + '</span>';
        }
      }
    }
  }
  var special_discount = parseInt($('.CollectionInner__Products').attr('discount_const'));
  var hasDiscount_class = document.querySelector('.regular_customer_disc');
  html += '</div>';
  // if(document.body.classList.contains('regular_customer')) {
  //   html += '<div class="discount-tag"> <svg class="Icon Icon--sale" role="presentation" viewBox="0 0 24 24"><path d="M22.707 12.293l-11-11A1.002 1.002 0 0 0 11 1H2a1 1 0 0 0-1 1v9c0 .265.105.52.293.707l11 11a.997.997 0 0 0 1.414 0l9-9a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9zm6 8.414L8.586 13 10 11.586 14.414 16 13 17.414zm3-3L11.586 10 13 8.586 17.414 13 16 14.414z" fill="currentColor"></path></svg><span class="Product_discount"> Discount : ' + special_discount+'%'+ '</span></div> ';
  //     //   var hide_disc = document.querySelectorAll('.ProductItem__Price.without_customer_disc');
  //     // console.log('hide_disc',hide_disc);
  // }
  return html;
}

function buildLabels(data) {
  var product_labels = ''
  if (bcSfFilterConfig.custom.show_labels) {
    product_labels = '';
    var tags = data.tags;
    for (var k = 0; k < tags.length; k++) {
      var tag = tags[k];
      if (tag.indexOf('__label') != -1) {
        product_labels += '<span class="ProductItem__Label ProductItem__Label--custom Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
        break;
      }
    }
    var promotionMetafield = _.find(data.metafields, { "namespace": "promotions", "key": "members_only" });
    if(promotionMetafield){
      product_labels += '<span class="ProductItem__Label ProductItem__Label--custom Heading Text--subdued">' + window.languages.promotionLabel + '</span>';
    }
    if (!soldOut) {      
      if (onSale)
        product_labels += '<span class="ProductItem__Label ProductItem__Label--sale wwwwww Heading Text--subdued">' + (data.tags.indexOf('weekly_promo') !== -1 ? 'Limited Offer' : bcSfFilterConfig.label.sale) + '</span>';
    } else {
      if (data.tags.indexOf('link-only') <= -1){
        product_labels += ' <span class="ProductItem__Label ProductItem__Label--soldout Heading Text--subdued">' + bcSfFilterConfig.label.sold_out + '</span>';
      }
    }
    var html = '';
    if (product_labels != '') {
      html += '<div class="ProductItem__LabelList">';
      html += product_labels;
      html += '</div>';
    }
  }
  return html;
}

function buildWishlist(data, indx) {
  var html = '<div class="ProductItem__Wishlist mmm">';
  html += '<div data-wlh-id="{{itemId}}" data-wlh-link="{{itemUrl}}" data-wlh-variantid="'+data.variants[0].id+'" data-wlh-price="499.00" data-wlh-name="'+data.title+'" data-wlh-image="{{itemImages}}" class="wishlist-hero-custom-button wishlisthero-floating" data-wlh-mode="icon_only" data-wlh-view="Collection" style="left: auto;"><div><button aria-label="Add to wishlist" title="Add to wishlist" class="" style="color: rgb(27, 25, 27); background: none; border-radius: 100%; margin: 0px; opacity: 0.9; border: none; line-height: normal; height: 40px; display: block; padding: 0px 20px; font-size: 14px; text-align: center; overflow: hidden; outline: none; position: relative; cursor: pointer;"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="rgb(144, 86, 162)"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg></button></div></div>';
  //html += '<button class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="{{itemId}}">' + window.icons.wishlist + '</button>';
  html += '</div>';
  return html;
}

function buildReviews(data, index) {
  let starRatingMarkup = '<div class="StarRating"><div class="internal_container">';
  const productStarRating = data.review_ratings;

  for (let i = 1; i <= 5; i++) {
    if (i <= productStarRating) {
      // Full star
      starRatingMarkup += '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"  width="15" height="15"><path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(253,170,32,1)" fill="rgba(253,170,32,1)"></path></svg>';
    } else if (i - 0.5 === productStarRating) {
      // Half star
      starRatingMarkup += `<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"  width="15" height="15"><linearGradient id="half-fill-${i}" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="50%" style="stop-color:rgba(253,170,32,1);"/><stop offset="50%" style="stop-color:transparent;"/></linearGradient><path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(253,170,32,1)" fill="url(#half-fill-${i})"></path></svg>`;
    } else {
      // Empty star
      starRatingMarkup += '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"  width="15" height="15"><path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(253,170,32,1)" fill="transparent"></path></svg>';
    }
  }
  if(productStarRating != 0){starRatingMarkup += `${data.review_ratings}.0 <br> ${data.review_count} Reviews`;}
  starRatingMarkup += '</div></div>';
  return starRatingMarkup;
}

function canQuickAddProduct(data) {
  return data.variants && data.variants.length === 1 && data.available;
}

function buildAction(data, indx) {
  var html = '';

  var productProperties = createProductProperties();
  
  function createProductProperties(){
    var tagsList = data.tags.join(',');


    var outputProperties = [
      {
        name: '_offer',
        prefix: 'Offer|'
      },
      {
        name: '_members_only',
        prefix: 'Members Only'
      },
      {
        name: '_category',
        prefix:'Category|'
      },
      {
        name: '_kit_product',
        prefix:'Kit Product'
      },
      {
        name: '_membership_product',
        prefix:'Membership Product'
      },
      {
        name: '_access_type',
        prefix: 'Access Type|'
      }
    ];


    for (var i = 0; i < outputProperties.length; i++) {
      var value = outputProperties[i];
      for (var k = 0; k < data.tags.length; k++) {
        var tag = data.tags[k];
        if(tag.indexOf(value.prefix) > -1){
          if (tag.indexOf('|') > -1) {
            outputProperties[i].value = tag.split('|')[1];
          }
          else {
            outputProperties[i].value = true;
          }
        }
      }
    }

    outputProperties.push({
      name: '_price',
      value: Shopify.formatMoney( data.price ).toString()
    });

    var properties = ' data-properties_promotion_id="{{_promotion_id}}"'
      +' data-properties_access_type="{{_access_type}}"'
      +' data-properties_members_only="{{_members_only}}"'
      +' data-properties_offer="{{_offer}}"'
      +' data-properties_category="{{_category}}"'
      +' data-properties_membership_product="{{_membership_product}}"'
      +' data-properties_kit_product="{{_kit_product}}"'
      +' data-properties_price="{{_price}}"'
      +' data-properties_product_type="{{product_type}}"';
    

    if (data.metafields.length > 0) {
      var maxQuantity = _.find(data.metafields, { "namespace": "max_qty_promotion", "key": "quantity" });
      var minSpend = _.find(data.metafields, { "namespace": "min_spend_promotion", "key": "price" });
      var promotionId = _.find(data.metafields, { "namespace": "promotions", "key": "promotion_id" });
      var locationInventory = _.find(data.metafields, { "namespace": "custom", "key": "location" });


      if(maxQuantity && maxQuantity.value.length > 0){
        outputProperties.push({
          name: '_max_quantity',
          value: maxQuantity.value
        });
        properties += ' data-properties_max_quantity="{{_max_quantity}}"';
        if (parseInt(maxQuantity.value) == 1) {
          outputProperties.push({
            name: '_hide_quantity',
            value: true
          });
          properties += ' data-properties_hide_quantity="{{_hide_quantity}}"';
        }
      }
      if(minSpend && minSpend.value.length > 0){
        outputProperties.push({
          name: '_min_spend',
          value: minSpend.value * 100
        });
        properties += 'data-properties_min_spend="{{_min_spend}}"';
      }
      var promotionIdValue = ''
      if(promotionId && promotionId.value.length > 0){
        promotionIdValue = promotionId.value
      }
      outputProperties.push({
        name: '_promotion_id',
        value: promotionIdValue
      });

    } else if ( data.metafields == 0 ){
      outputProperties.push({
        name: '_promotion_id',
        value: ''
      });
    }

    properties = properties.replace('{{product_type}}',data.product_type);
    // properties = properties.replace('{{_locationInventory}}',data.metafields);
    // console.log('data.metafields', data);

    for (var i = 0; i < outputProperties.length; i++) {
      var name = outputProperties[i].name;
      var value = outputProperties[i].value || '';
      
      // if (value && typeof value === 'number' || typeof value === 'boolean'){
      //   var replaceString = '"{'+name+'}"';
      //   properties.replace(replaceString,value);
      // }
      // else {
        
      // }
      var replaceString = '{{'+name+'}}';
      properties = properties.replace(replaceString,value);
    }

    return properties;
  }




  var quick_add_type = 'regular';

  

  if(data.product_type == 'Membership' || data.product_type == 'membership'){
    quick_add_type = 'view-more';
  }

  if (data.metafields.length > 0) {

    var consultantKitMetafield = _.find(data.metafields, { "namespace": "details", "key": "kit_product" });
    if(consultantKitMetafield && consultantKitMetafield.value.length > 0){
      quick_add_type = 'view-more';
    }

    var access_type = _.find(data.metafields, { "namespace": "promotions", "key": "access_type" });
    if(access_type && access_type.value.length > 0 && access_type.value != 'all'){
       quick_add_type = 'restricted';

       if (window.shop.customer.is_logged_in){
         if(window.shop.customer.loyalty_tier.length > 0){
           var access_tiers = '';
           switch(access_type.value) {
             case 'bronze-and-up':
               access_tiers = 'bronze,silver,gold';
               break;
             case 'silver-and-up':
               access_tiers = 'silver,gold';
               break;
             case 'gold-only':
               access_tiers = 'gold';
             default:
               // code block
           }

           if (access_tiers.indexOf(window.shop.customer.loyalty_tier) > -1){
             quick_add_type = 'regular';
           }
         }
       }
    }

    
  }

  if (data.variants.length > 1){
    quick_add_type = 'more-options';
  }

  if(data.tags.indexOf('view-more-only') > -1){
    quick_add_type = 'view-more';
  }

  if (!data.available){
    quick_add_type = 'sold-out';
  }
  
  if (data.tags.indexOf('link-only') >-1){
    quick_add_type = 'view-more'
  }

  html += '<div class="ProductItem__Action freegift 000 ' + (data.tags.includes('hideProduct') ? 'hideProduct' : '') + '">';

  switch(quick_add_type) {
    case 'regular':
      html += '<button class="ProductItem__ActionButton Button Button--secondary Button--full" data-opens-cart-drawer="true" data-displays-success="true" data-success-text="Added %icon.checkmark%" '+productProperties+' data-cart-add="' + data.variants[0].id + '" data-product-sku="' + data.skus[0] + '">';
      html += window.theme.strings.productQuickAdd;
      html += '</button>';
      break;
    case 'sold-out':
      html += '<a class="ProductItem__ActionButton Button Button--disabled Button--o Button--full" href="{{itemUrl}}">';
      html += '<span style="white-space: normal">' + window.languages.productSoldOut + '</span>';
      html += '</a>';
      break;
    case 'view-more':
      html += '<a class="ProductItem__ActionButton Button Button--secondary Button--full" href="{{itemUrl}}">';
      html += '<span style="white-space: normal">' + window.theme.strings.productViewMore + '</span>';
      html += '</a>';
      break;
    case 'more-options':
      html += '<a class="ProductItem__ActionButton Button Button--secondary Button--full" href="{{itemUrl}}">';
      html += '<span style="white-space: normal">' + window.theme.strings.productMoreAvailable + '</span>';
      html += '</a>';
      break;
    case 'restricted':
      html += '<a class="ProductItem__ActionButton Button Button--secondary Button--full" href="{{itemUrl}}">';
      html += '<span style="white-space: normal">' + window.theme.strings.productRestricted + '</span>';
      html += '</a>';
      break;
      
    default:
      // code block
  };

  html += '</div>';
  return html
}

function buildInfo(data, indx) {
  var html = '';
  if (bcSfFilterConfig.custom.show_product_info) {
    var infoClass = (!bcSfFilterConfig.custom.use_horizontal) ? 'ProductItem__Info--' + bcSfFilterConfig.custom.product_info_alignment : '';
    html += '<div class="ProductItem__Info ' + infoClass + ' ">';
    if (bcSfFilterConfig.custom.show_vendor) {
      html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
    }
    html += '<h2 class="ProductItem__Title Heading h2">';
    html += '<a href="{{itemUrl}}">' + data.title + '</a>';
    html += '</h5>';
    if (bcSfFilterConfig.custom.show_color_swatch) {
      html += buildSwatch(data, bcsffilter, indx);  
    }    
    html += buildPrice(data);
    html += '</div>';
  }
  return html;
}

function buildSwatch(data, ob, indx) {
  var _this = ob;
  var itemSwatchHtml = '';
  if (bcSfFilterConfig.custom.show_color_swatch) {
    var color_name = bcSfFilterConfig.custom.section_id + '-' + data.id + '-' + indx;
    data.options_with_values.forEach(function(option, index) {
      var option_name = option.name.toLowerCase();
      if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
        var values = '';
        itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
        var i = 0;
        data.variants.forEach(function(variant) {
          var temp = variant.merged_options.filter(function(obj) {
            obj = obj.toLowerCase();
            if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1)
              return obj;
          });
          temp = temp[0].split(':');
          var value = temp[1].toLowerCase();
          if (values.indexOf(value) == -1) {
            values = values + ',' + value;
            values = values.split(',');
            var size = '200,400,600,700,800,900,1000,1200';
            var supported_sizes = imageSize(size, variant.image);
            var color_image = _this.optimizeImage(variant.image);
            var name_color = value + '.png';
            var checked = (i == 0) ? 'checked=checked' : '';
            var dataImg = (variant.image != null) ? 'data-image-id="" data-image-url="' + variant.image + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1"' : '';
            var url_color = bcSfFilterMainConfig.general.asset_url.replace('bc-sf-filter.min.js', name_color);
            itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
            itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_name + '" value="' + value + '" data-variant-url="' + _this.buildProductItemUrl(data) + '?variant=' + variant.id + '"' + dataImg + '  aria-hidden="true">';
            itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_name + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
            itemSwatchHtml += '</div>';
            i++;
          }
        });
        itemSwatchHtml += '</div>';
      }
    });
  }
  return itemSwatchHtml;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        var classActive = (this.queryParams.sort == k) ? 'is-selected' : '';
        sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  var topSortingSelector = jQ(this.selector.topSorting);
  topSortingSelector.find('.Popover__Value').click(function(e) {
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
    jQ('.CollectionToolbar__Item--sort').trigger('click');
  })
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /**
   *  Call theme function 
   *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
   *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
   *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
  
  if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
  }  
  */

  // Fix image not load on Instagram browser - initialize swatch image
  // $(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function(){
  //   $(this).parent().parent().find('label.ColorSwatch').removeClass('active');
  //   $(this).addClass('active');
  //   var parent = $(this).parent();
  //   var productImage = $(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
  //   var variantInfo = parent.find('input.ColorSwatch__Radio');
  //   productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
  //   productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
  //   productImage.find('img.ProductItem__Image').hide();
  //   productImage.attr('href', variantInfo.data('variant-url'));
  //   console.log(variantInfo);
  //   $(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html('<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + bcsffilter.formatMoney(variantInfo.data('variant-price')) + '</span>');
  // })
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {

  if ('_swat' in window) {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(_swat) {
      var products = [];

      data.products.forEach(function(product) {
        var image_src = product.images && product.images[0] ? product.images[0].src : undefined;
        var productCopy = product;
        productCopy.featured_image = image_src;
        products.push(productCopy);
      });

      setTimeout(function() {
        _swat.mapShopifyProducts(products);
        _swat.initializeActionButtons('#bc-sf-filter-products');
      }, 1)
    });
  } else {
    console.warn('Wishlist+ may not be installed correctly')
  }
};

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath; 
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

BCSfFilter.prototype.sortFilterOptionValue = function(data) {
    var sortType = data.hasOwnProperty('sortType') && data.sortType ? data.sortType : 'key-asc';
    var sortKey = sortType.split('-')[0];
    if (data.filterType == 'collection' && sortKey == 'key') sortKey = 'label';
    if (data.values && data.values.length > 0) {
        data.values.sort(function(a, b) {
            a = a[sortKey].toString().toLowerCase(), b = b[sortKey].toString().toLowerCase();
            function chunkify(t) {
                var tz = new Array();
                var bcsfX = 0, bcsfY = -1, n = 0, i, j;

                while (i = (j = t.charAt(bcsfX++)).charCodeAt(0)) {
                    var m = (i == 46 || (i >=48 && i <= 57));
                    if (m !== n) {
                        tz[++bcsfY] = "";
                        n = m;
                    }
                    tz[bcsfY] += j;
                }
                return tz;
            }

            var aa = chunkify(a);
            var bb = chunkify(b);
            for (bcsfX = 0; aa[bcsfX] && bb[bcsfX]; bcsfX++) {
                if (aa[bcsfX] !== bb[bcsfX]) {
                    var c = Number(aa[bcsfX]), d = Number(bb[bcsfX]);
                    if (c == aa[bcsfX] && d == bb[bcsfX]) {
                        return c - d;
                    } else return (aa[bcsfX] > bb[bcsfX]) ? 1 : -1;
                }
            }
            return aa.length - bb.length;
        });
    }
    // Reverse
    if (sortType.indexOf('desc') > -1) data.values.reverse();

    return data.values;
};